import React from 'react'
import { withIcon } from '../../withIcon'

interface ShareNodesIconProps {
  size?: string
  color?: string
}

function ShareNodesIcon (props: ShareNodesIconProps) {
  const {
    size = '16px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path d="M5.72667 9.057L10.28 11.843M10.2733 4.157L5.72667 6.943M14 3.1C14 4.2598 13.1046 5.2 12 5.2C10.8954 5.2 10 4.2598 10 3.1C10 1.9402 10.8954 1 12 1C13.1046 1 14 1.9402 14 3.1ZM6 8C6 9.1598 5.10457 10.1 4 10.1C2.89543 10.1 2 9.1598 2 8C2 6.8402 2.89543 5.9 4 5.9C5.10457 5.9 6 6.8402 6 8ZM14 12.9C14 14.0598 13.1046 15 12 15C10.8954 15 10 14.0598 10 12.9C10 11.7402 10.8954 10.8 12 10.8C13.1046 10.8 14 11.7402 14 12.9Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default withIcon(ShareNodesIcon)
